/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clinicDoctorControllerCreate } from '../fn/clinic-doctors/clinic-doctor-controller-create';
import { ClinicDoctorControllerCreate$Params } from '../fn/clinic-doctors/clinic-doctor-controller-create';
import { clinicDoctorControllerDelete } from '../fn/clinic-doctors/clinic-doctor-controller-delete';
import { ClinicDoctorControllerDelete$Params } from '../fn/clinic-doctors/clinic-doctor-controller-delete';
import { clinicDoctorControllerFilter } from '../fn/clinic-doctors/clinic-doctor-controller-filter';
import { ClinicDoctorControllerFilter$Params } from '../fn/clinic-doctors/clinic-doctor-controller-filter';
import { clinicDoctorControllerFindOne } from '../fn/clinic-doctors/clinic-doctor-controller-find-one';
import { ClinicDoctorControllerFindOne$Params } from '../fn/clinic-doctors/clinic-doctor-controller-find-one';
import { clinicDoctorControllerGetClinicsForDoctor } from '../fn/clinic-doctors/clinic-doctor-controller-get-clinics-for-doctor';
import { ClinicDoctorControllerGetClinicsForDoctor$Params } from '../fn/clinic-doctors/clinic-doctor-controller-get-clinics-for-doctor';
import { clinicDoctorControllerUpdate } from '../fn/clinic-doctors/clinic-doctor-controller-update';
import { ClinicDoctorControllerUpdate$Params } from '../fn/clinic-doctors/clinic-doctor-controller-update';
import { ResponseClinicDoctorDto } from '../models/response-clinic-doctor-dto';
import { ResponseClinicDto } from '../models/response-clinic-dto';

@Injectable({ providedIn: 'root' })
export class ClinicDoctorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clinicDoctorControllerCreate()` */
  static readonly ClinicDoctorControllerCreatePath = '/thalea-clinics/clinic-doctors';

  /**
   * Create a new clinic-doctor relationship.
   *
   * Creates a new relationship between a clinic and a doctor within a tenant context.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerCreate$Response(params: ClinicDoctorControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDoctorDto>> {
    return clinicDoctorControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new clinic-doctor relationship.
   *
   * Creates a new relationship between a clinic and a doctor within a tenant context.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerCreate(params: ClinicDoctorControllerCreate$Params, context?: HttpContext): Observable<ResponseClinicDoctorDto> {
    return this.clinicDoctorControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDoctorDto>): ResponseClinicDoctorDto => r.body)
    );
  }

  /** Path part for operation `clinicDoctorControllerFindOne()` */
  static readonly ClinicDoctorControllerFindOnePath = '/thalea-clinics/clinic-doctors/{tenant}/{clinicId}/{doctorId}';

  /**
   * Get a clinic-doctor relationship by key.
   *
   * Retrieves a specific clinic-doctor relationship using its composite key.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerFindOne$Response(params: ClinicDoctorControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDoctorDto>> {
    return clinicDoctorControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a clinic-doctor relationship by key.
   *
   * Retrieves a specific clinic-doctor relationship using its composite key.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerFindOne(params: ClinicDoctorControllerFindOne$Params, context?: HttpContext): Observable<ResponseClinicDoctorDto> {
    return this.clinicDoctorControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDoctorDto>): ResponseClinicDoctorDto => r.body)
    );
  }

  /** Path part for operation `clinicDoctorControllerUpdate()` */
  static readonly ClinicDoctorControllerUpdatePath = '/thalea-clinics/clinic-doctors/{tenant}/{clinicId}/{doctorId}';

  /**
   * Update an existing clinic-doctor relationship.
   *
   * Updates an existing relationship between a clinic and a doctor.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerUpdate$Response(params: ClinicDoctorControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDoctorDto>> {
    return clinicDoctorControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing clinic-doctor relationship.
   *
   * Updates an existing relationship between a clinic and a doctor.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerUpdate(params: ClinicDoctorControllerUpdate$Params, context?: HttpContext): Observable<ResponseClinicDoctorDto> {
    return this.clinicDoctorControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDoctorDto>): ResponseClinicDoctorDto => r.body)
    );
  }

  /** Path part for operation `clinicDoctorControllerDelete()` */
  static readonly ClinicDoctorControllerDeletePath = '/thalea-clinics/clinic-doctors/{tenant}/{clinicId}/{doctorId}';

  /**
   * Delete a clinic-doctor relationship.
   *
   * Removes the relationship between a clinic and a doctor.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerDelete$Response(params: ClinicDoctorControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clinicDoctorControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a clinic-doctor relationship.
   *
   * Removes the relationship between a clinic and a doctor.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerDelete(params: ClinicDoctorControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.clinicDoctorControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clinicDoctorControllerFilter()` */
  static readonly ClinicDoctorControllerFilterPath = '/thalea-clinics/clinic-doctors/filter';

  /**
   * Filter clinic-doctor relationships.
   *
   * Retrieves clinic-doctor relationships based on the specified filter criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerFilter$Response(params: ClinicDoctorControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDoctorDto>>> {
    return clinicDoctorControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter clinic-doctor relationships.
   *
   * Retrieves clinic-doctor relationships based on the specified filter criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicDoctorControllerFilter(params: ClinicDoctorControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseClinicDoctorDto>> {
    return this.clinicDoctorControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseClinicDoctorDto>>): Array<ResponseClinicDoctorDto> => r.body)
    );
  }

  /** Path part for operation `clinicDoctorControllerGetClinicsForDoctor()` */
  static readonly ClinicDoctorControllerGetClinicsForDoctorPath = '/thalea-clinics/clinic-doctors/{tenant}/{doctorId}';

  /**
   * Get clinics for a specific doctor.
   *
   * Retrieves all clinics associated with a doctor, optionally filtered by specialization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicDoctorControllerGetClinicsForDoctor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerGetClinicsForDoctor$Response(params: ClinicDoctorControllerGetClinicsForDoctor$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDto>>> {
    return clinicDoctorControllerGetClinicsForDoctor(this.http, this.rootUrl, params, context);
  }

  /**
   * Get clinics for a specific doctor.
   *
   * Retrieves all clinics associated with a doctor, optionally filtered by specialization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicDoctorControllerGetClinicsForDoctor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicDoctorControllerGetClinicsForDoctor(params: ClinicDoctorControllerGetClinicsForDoctor$Params, context?: HttpContext): Observable<Array<ResponseClinicDto>> {
    return this.clinicDoctorControllerGetClinicsForDoctor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseClinicDto>>): Array<ResponseClinicDto> => r.body)
    );
  }

}
